<template>
  <div class="fill-height">
    <AuthWindow @afterLogin="afterLogin"/>
    <SimiaWelcomeModal v-model="simiaWelcomeModal"/>
  </div>
</template>

<script>
import AuthWindow from "@/components/Auth/AuthWindow";
import SimiaWelcomeModal, {shouldShowSimiaWelcome} from "@/components/UserJourney/SimiaWelcomeModal.vue";
import {hasIntakePending} from "@/intake/intakeState";
import {loginReturnTarget} from "@/router/loginReturn";

export default {
  components: {AuthWindow, SimiaWelcomeModal},
  data() {
    return {
      simiaWelcomeModal: false,
    }
  },
  methods: {
    afterLogin() {
      const returnTarget = loginReturnTarget(this.$route, this.$router)
      if (returnTarget) {
        this.$router.replace(returnTarget)
      } else if (hasIntakePending()) {
        this.$router.push({name: 'intakeScreening', params: {lang: this.$route.params.lang || 'fa'}})
      } else {
        this.$router.push({name: "dashboard"})
      }
    }
  },
  mounted() {
    const therapistId = this.$route.query.assign_therapist
    if (therapistId) {
      localStorage.setItem('assign_therapist', therapistId)
    }
    if (shouldShowSimiaWelcome(this.$route)) {
      this.simiaWelcomeModal = true
    }
  }
}
</script>

<style scoped>

</style>